import { createSlice } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

const initialState = {
    loading: false,
    text: 'Loading',
}

const loadingSlice = createSlice({
    name: 'Loading',
    initialState,
    reducers: {
        changeLoading(state, { payload }) {
            state.loading = payload
        },
        changeText(state, { payload }) {
            state.text = payload
        },
    },
})

export const { actions } = loadingSlice
export default loadingSlice.reducer

export const useLoadingActions = () => {
    const dispatch = useDispatch()

    const changeLoading = loading => {
        dispatch(actions.changeLoading(loading))
    }

    const changeText = text => {
        dispatch(actions.changeText(text))
    }

    return {
        changeLoading,
        changeText,
    }
}
